import type { ComponentProps } from 'react';
import { OwcButton } from '@one/react';

export type PocButtonProps = ComponentProps<typeof OwcButton>;

export const PocButton: React.FC<PocButtonProps> = (props) => <OwcButton {...props} />;
